import { Link } from "react-router-dom";
export default function Contact() {
  window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <>
        <div className="page-head">
          <div className="container">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Contact</li>
            </ol>
            <h1>Contact With Us</h1>
            <p className="text-mono" style={{ color: "#B9C0F0" }}>
              We usually reply within a few hours.
            </p>
          </div>
        </div>
        <section className="section">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 mb-5 mb-lg-0">
                <div className="contact-block">
                  <div className="contact-icon">📞</div>
                  <div>
                    <h5 className="mb-1">Telephone Number</h5>
                    <a href="tel:7004654910">+91 7004654910</a>
                  </div>
                </div>
                <div className="contact-block">
                  <div className="contact-icon">📧</div>
                  <div>
                    <h5 className="mb-1">Email Address</h5>
                    <a href="mailto:learning2earningsupport@gmail.com">
                      learning2earningsupport@gmail.com
                    </a>
                  </div>
                </div>
                <div className="contact-block">
                  <div className="contact-icon">📍</div>
                  <div>
                    <h5 className="mb-1">Head Office</h5>
                    <p className="mb-0 text-muted-soft">
                      AMRIT PLAZA, JAMTARA ROAD, NIRSA, DHANBAD, JHARKHAND,
                      828205
                    </p>
                  </div>
                </div>
                <a
                  href="https://wa.me/7004654910?text=Hi%2C%20I%20saw%20your%20website%2C%20I%27m%20interested%20in%20your%20courses.%20Could%20you%20share%20more%20details%3F"
                  className="btn btn-wa btn-block mt-4"
                  target="_blank"
                  rel="noopener"
                >
                  Chat on WhatsApp
                </a>
              </div>
              <div className="col-lg-7">
                <div className="form-panel">
                  <h4 className="mb-4">Send Us a Message</h4>
                  <form>
                    <div className="form-row">
                      <div className="col-md-6 form-group">
                        <label>Full Name</label>
                        <input className="form-control" required="" />
                      </div>
                      <div className="col-md-6 form-group">
                        <label>Phone Number</label>
                        <input className="form-control" required="" />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Email Address</label>
                      <input
                        type="email"
                        className="form-control"
                        required=""
                      />
                    </div>
                    <div className="form-group">
                      <label>Message</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        required=""
                        defaultValue={""}
                      />
                    </div>
                    <button className="btn btn-brass btn-lg" type="submit">
                      Send Message
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div className="map-frame mt-5">
              <iframe
                src="https://www.google.com/maps?q=23.7844370,86.7068534&z=17&output=embed"
                width={600}
                height={450}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
              />
            </div>
          </div>
        </section>
      </>
    </>
  );
}
